import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useEffect, useState } from 'react';
import { Alert, Badge, Container, Image } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { LinkContainer } from 'react-router-bootstrap';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import ApiFetch from './ApiFetch';
import CampaignMessage from './CampaignMessage';
import Category from './Category';
import Dialog from './Dialog';
import FavoriteIcon from './FavoriteIcon';
import Footer from './Footer';
import Header from './Header';
import { useTranslation } from "react-i18next";

const Invite = () => {
    async function refererUser(displayIdOrUserId){
        return await new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/regist/referrer",{displayIdOrUserId:displayIdOrUserId}).then((r)=>r.json().then((json)=>{
            return json
        }))
    }

    // ナビゲーション
    const navigate = useNavigate()
    const location = useLocation()
    const param = useParams()

	useEffect(() => {
		document.querySelector("title").textContent = "招待を受けて登録 - アワートAI"
        if(param.displayIdOrUserId === undefined){
            alert("不正な招待リンクです。")
            return
        }
        refererUser(param.displayIdOrUserId).then(r => {
            if(r.result){
                navigate("/regist-select")
            }
        })
	},[location.pathname])

    return(
    <div className="wrapper">
        <header className="App-header"></header>
        <Header />
        <Category />
        <Footer />
    </div>
    )
}

export default Invite;
